import CustomHeader from "./CustomDatePicker/CustomHeader";
import DatePicker from "react-datepicker";
import {ExampleCustomInput} from "./ImmobilieMieten";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";
import {ScreenNumber, useMediaQuery} from "../../hooks/useMediaQuery";
import IconCalender from "../../data/Icons/leon-inmobiliaria-icons-kalender.svg";
import {forwardRef, useEffect, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";

interface AbreiseSelectPropsInterface {
	onStartDateChange: (date: Date | null) => void;
	onEndDateChange: (date: Date | null) => void;
	startDate?: Date | null;
	endDate?: Date | null;
}

export default function AbreiseSelect(props: AbreiseSelectPropsInterface) {
	const [openDatePicker, setOpenDatePicker] = useState<boolean>();
	const ExampleCustomInputTo = forwardRef(
		({value, onClick}: any, ref): any => {
			const [date, setDate] = useState();
			useEffect(() => {
				setDate(value.toString().split("-").slice(-1)[0]);
			}, [value]);

			return (
				<button
					type="button"
					className="w-full border-none input-field flex justify-between items-center p-2 h-[40px] shadow-none gap-1 text-[12px] lg:text-base"
					onClick={() => {
						onClick;
						!openDatePicker && setOpenDatePicker(undefined);
						openDatePicker === undefined && setOpenDatePicker(true);
					}}
					ref={ref as any}
				>
					{date}
					<IconCalender className="w-3 lg:w-5"/>
				</button>
			);
		}
	);
	ExampleCustomInputTo.displayName = "ExampleCustomInput";

	const router = useRouter();
	const {t} = useTranslation();
	const {currentScreenAsNumber} = useMediaQuery();

	const onDateRangeChange = (dates: [Date | null, Date | null]) => {
		const [start, end] = dates;
		props.onStartDateChange(start);
		props.onEndDateChange(end);
		if (start && end) {
			setOpenDatePicker(false);
		}
	};

	return (
		<label className="shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)] flex items-center px-1 md:px-2 md:min-w-[128px]">
			<DatePicker
				open={openDatePicker}
				dateFormat="dd.MM.yyyy"
				selected={props.endDate}
				filterDate={(date) => (Boolean(props.startDate) === true && Boolean(props.endDate) !== true) || date.getDay() !== 0}
				onChange={(dates) => {
					onDateRangeChange(dates);
				}}
				calendarClassName="!border-none p-7 md:p-10 !flex md:!text-lg !font-sans md:!text-[18px] !tracking-[2.7px]"
				renderCustomHeader={(props) => (
					<>
						<CustomHeader
							twoMonth={currentScreenAsNumber > ScreenNumber.lg}
							{...props}
						/>
					</>
				)}
				startDate={props.startDate}
				endDate={props.endDate}
				renderDayContents={(day, date) => (
					<div className="flex-1 ">
						<p className="font-normal lg:!text-[18px]">{day}</p>
					</div>
				)}
				selectsRange
				calendarStartDay={1}
				customInput={<ExampleCustomInputTo/>}
				locale={router.locale}
				showPopperArrow={false}
				monthsShown={currentScreenAsNumber > ScreenNumber.lg ? 2 : 1}
				disabledKeyboardNavigation
				minDate={new Date()}
				onClickOutside={() => setOpenDatePicker(undefined)}
			/>
			{!props.endDate && (
				<span className="text-[12px] md:text-[16px] text-[#85888c]">
					{t("components.abreiseSelect.departure")}
				</span>
			)}
		</label>
	);
}
